// Keep track of pending requests to cancel them
let currentAbortController: AbortController | null = null;

async function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onloadend = () => {
      if (reader.result) {
        const dataUrl = String(reader.result);
        // Remove data URL prefix (data:audio/...;base64,) to get just base64
        const base64 = dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl;
        resolve(base64);
      } else {
        console.error('FileReader result is null');
        reject(new Error('Failed to read blob data'));
      }
    };
    
    reader.onerror = (event) => {
      console.error('FileReader error:', event);
      reject(new Error(`Failed to read blob: ${(reader as any).error?.message || 'Unknown error'}`));
    };
    
    try {
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error('Error calling readAsDataURL:', error);
      reject(error);
    }
  });
}

async function transcribe(blob: Blob, language: string, token: string, isChunk = false) {
  // Cancel previous chunk request if this is a new chunk
  if (isChunk && currentAbortController) {
    currentAbortController.abort();
  }

  // Create new abort controller for this request
  const abortController = new AbortController();
  if (isChunk) {
    currentAbortController = abortController;
  }

  console.log('STT transcribe called:', {
    blobSize: blob.size,
    blobType: blob.type,
    language: language,
    isChunk: isChunk
  });
  
  try {
    // For small chunks, convert directly; for final recording, use more efficient method
    const audioBase64 = await blobToBase64(blob);
    
    const url = `${process.env.REACT_APP_API_URL}/api/v1/stt`;
    const payload = { audio: audioBase64, language, mime: blob.type };
    const headers = { Authorization: token };
    
    console.log('Sending to STT API...');
    
    // Use fetch with AbortController for cancellation and timeout
    // Note: Vercel Hobby plan has 10s timeout, Pro has 60s. Use 25s to be safe for Pro plan.
    const timeoutController = new AbortController();
    const timeoutId = setTimeout(() => timeoutController.abort(), 25000);
    
    // Listen to timeout signal and abort the main controller
    timeoutController.signal.addEventListener('abort', () => {
      if (!abortController.signal.aborted) {
        abortController.abort();
      }
    });
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          ...headers
        },
        body: JSON.stringify(payload),
        signal: abortController.signal
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      console.log('STT result:', result);
      
      return result;
    } catch (error: any) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError' || abortController.signal.aborted) {
        console.log('STT request cancelled or timed out');
        throw new Error('Request cancelled');
      }
      throw error;
    }
  } catch (error: any) {
    console.error('STT transcribe error:', error);
    throw error;
  }
}

const stt = { transcribe };
export default stt;




